export const eiKeys = {
	all: ["emotional-intelligence"] as const,
	profiles: () => [...eiKeys.all, "profile"] as const,
	profile: (userId: number) => [...eiKeys.profiles(), userId] as const,
	test: () => [...eiKeys.all, "test"] as const,
	result: () => [...eiKeys.all, "result"] as const,
	leaderboards: () => [...eiKeys.all, "leaderboard"] as const,
	leaderboard: (highlightUserId?: number) =>
		[...eiKeys.leaderboards(), highlightUserId ?? "self"] as const,
} as const
